// 設備フィルタの固定リスト（slug + label + icon）。
// label は RoomTypeFeature.displayName の実データ値。icon は Figma（5179-11914）準拠。
// condition-filter（一覧 UI / チップ）と sp-search-bar（チップラベル）で共有する。
// dog-run（ドッグラン）は意図的に除外。対象は 温泉/サウナ/ドッグフレンドリー/ワーケーション ＋ EV の5種のみ（Figma 5179-11914 仕様）。
export const FACILITY_FILTERS = [
  { slug: "onsen", label: "天然温泉", icon: "/i/icon_onsen.svg" },
  { slug: "sauna", label: "サウナ", icon: "/i/icon_sauna.svg" },
  {
    slug: "dog-friendly",
    label: "ドッグフレンドリー",
    icon: "/i/icon_dogfriendly.svg",
  },
  { slug: "display", label: "ワーケーション", icon: "/i/icon_workation.svg" },
] as const;

// EV充電器は設備セクションに統合（Figma 5179-11914）
export const EV_CHARGER_ICON = "/i/icon_evstation.svg";
